import {merge} from 'rxjs';
import {maoMsg$ as marginMaoMsg$} from './mao';
import {utaMaoMsg$, allMaoMsg$} from './uta-mao';

export {allMaoMsg$};

export const maoMsg$ = merge(marginMaoMsg$, utaMaoMsg$);
